module.exports = __webpack_public_path__ + "img/ai4.9ee3d8f8.png";